import { Box, BoxProps, Flex, Text } from "@chakra-ui/layout";
import { Menu } from "features/menu/typings/menu";
import colors from "core/resources/theme/colors";
import Fade from "react-fade-in";
import { trackEvent } from "infra/helpers/event";
import Container from "components/Container";

interface HeaderMenuItemProps extends BoxProps {
  item: Menu;
  submenuOpen: boolean;
  onCloseSubmenu: any;
  onOpenSubmenu: any;
  color?: string;
}

function HeaderMenuItem({
  item,
  submenuOpen,
  onCloseSubmenu,
  onOpenSubmenu,
  color,
  ...props
}: HeaderMenuItemProps) {
  return (
    <>
      <Flex
        _hover={{
          cursor: "pointer",
          color: color || colors.primary,
        }}
        onClick={() => {
          if (typeof item.action === "function") {
            item.action();
          } else if (item.children.length) {
            onOpenSubmenu();
          }
        }}
        transition="linear all .1s"
        py="24px"
        px="8px"
        fontSize="14px"
        gridGap="8px"
        color={color || (submenuOpen ? colors.primary : colors.darkBlueGray)}
        pos="relative"
        cursor="pointer"
        onMouseOver={() => {
          onCloseSubmenu();

          if (item.children.length) {
            onOpenSubmenu();
          }
        }}
        {...props}
      >
        {item.icon}
        {item.title}

        {submenuOpen ? (
          <Flex
            w="max-content"
            h="max-content"
            onMouseLeave={() => {
              onCloseSubmenu();
            }}
            rounded={5}
            pos="absolute"
            top="100%"
            margin="auto"
            transform="translateX(-50%)"
            left="50%"
            flexDir="column"
          >
            <Flex h="30px" w="100%" bg="trasparent" />
            <Flex
              w="100%"
              h="max-content"
              bg={colors.white}
              rounded={5}
              p={4}
              pb={8}
              boxShadow="dark-lg"
            >
              <Container>
                <Fade visible={submenuOpen}>
                  <Flex
                    gridGap="32px"
                    flexWrap="wrap"
                    // justifyContent="space-between"
                  >
                    {item.children.map((submenu, index) => (
                      <Flex w="220px" key={index} flexDir="column">
                        <Box pt="16px" mb="80px" h="35px">
                          <Flex
                            w="40px"
                            h="40px"
                            mb="20px"
                            rounded="20px"
                            bg={submenu.bg}
                            justifyContent="center"
                            alignItems="center"
                            color={submenu.color}
                          >
                            {submenu.icon}
                          </Flex>

                          <Text
                            fontSize="16px"
                            fontWeight="bold"
                            color={submenu.color}
                          >
                            {submenu.title}
                          </Text>
                        </Box>

                        <Flex gridGap="16px" flexDirection="column">
                          {submenu.children.map((child, index2) => (
                            <Flex
                              cursor="pointer"
                              key={index2}
                              flexDir="column"
                              fontWeight="bold"
                              onClick={(e) => {
                                if (typeof child.action === "function") {
                                  trackEvent(`ClickMenu-${child.title}`);
                                  child.action(e.metaKey || e.ctrlKey);
                                }

                                setTimeout(() => onCloseSubmenu(), 150);
                              }}
                            >
                              <Flex
                                flex="1"
                                justifyContent="start"
                                // alignItems="center"
                                opacity="0.6"
                                gap="4px"
                                _hover={{
                                  opacity: 1,
                                  textDecoration: "underline",
                                }}
                                transition="linear all .1s"
                                cursor="pointer"
                              >
                                {child.icon}
                                <Text
                                  // textAlign="center"
                                  fontSize="14px"
                                  color="black"
                                >
                                  {child.title}
                                </Text>
                              </Flex>
                            </Flex>
                          ))}
                        </Flex>
                      </Flex>
                    ))}
                  </Flex>
                </Fade>
              </Container>
            </Flex>
            <Flex
              bg={colors.white}
              w="20px"
              h="40px"
              position="absolute"
              top="13px"
              clipPath=" polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)"
              align="center"
              transform="translateX(50%)"
              right="50%"
            />
          </Flex>
        ) : null}
      </Flex>
    </>
  );
}

export default HeaderMenuItem;
